'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigurationServiceEndpoint = exports.getQuickSilverEndPoint = exports.getSesameEndpoint = exports.getLocationsServiceEndpoint = exports.getGeocoderServiceEndpoint = exports.getReviewsServiceEndpoint = exports.getSellerProfilesServiceEndpoint = exports.getTokenEndpoint = exports.getAuthServiceEndpoint = exports.getLhGatewayEndpoint = undefined;

var _url = require('../utils/url');

var LH_GATEWAY = _url.MICROSERVICES_DOMAINS.LH_GATEWAY,
    GEOCODER = _url.MICROSERVICES_DOMAINS.GEOCODER,
    LOCATIONS_SERVICE = _url.MICROSERVICES_DOMAINS.LOCATIONS_SERVICE,
    AUTH_SERVICE = _url.MICROSERVICES_DOMAINS.AUTH_SERVICE,
    SELLER_PROFILES = _url.MICROSERVICES_DOMAINS.SELLER_PROFILES,
    USER_REVIEWS = _url.MICROSERVICES_DOMAINS.USER_REVIEWS,
    SESAME = _url.MICROSERVICES_DOMAINS.SESAME,
    QUICKSILVER = _url.MICROSERVICES_DOMAINS.QUICKSILVER,
    CONFIGURATION = _url.MICROSERVICES_DOMAINS.CONFIGURATION;

// Have a look at the READ.me file for more information on how to enable and run a MS from local

var getLhGatewayEndpoint = exports.getLhGatewayEndpoint = function getLhGatewayEndpoint() {
  return (0, _url.getMsEndpointUrl)(LH_GATEWAY.NAME);
};

/**
 * @deprecated

 * deprecated in favor of `getTokenEndpoint()`
 * For more info see https://freightos.atlassian.net/browse/MPS-2753
 */
var getAuthServiceEndpoint = exports.getAuthServiceEndpoint = function getAuthServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(AUTH_SERVICE.NAME);
};
/**
 * getTokenEndpoint
 *
 * Get token from core
 *
 * @param app [String]
 * @param includeData [Boolean]
 *
 * @returns {string}
 */
var getTokenEndpoint = exports.getTokenEndpoint = function getTokenEndpoint() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'mp_auth_v2';
  var includeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return '/servlet/apptoken?app=' + app + '&includeData=' + includeData;
};

var getSellerProfilesServiceEndpoint = exports.getSellerProfilesServiceEndpoint = function getSellerProfilesServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(SELLER_PROFILES.NAME);
};

var getReviewsServiceEndpoint = exports.getReviewsServiceEndpoint = function getReviewsServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(USER_REVIEWS.NAME);
};

var getGeocoderServiceEndpoint = exports.getGeocoderServiceEndpoint = function getGeocoderServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(GEOCODER.NAME);
};

var getLocationsServiceEndpoint = exports.getLocationsServiceEndpoint = function getLocationsServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(LOCATIONS_SERVICE.NAME);
};

var getSesameEndpoint = exports.getSesameEndpoint = function getSesameEndpoint() {
  return (0, _url.getMsEndpointUrl)(SESAME.NAME);
};

var getQuickSilverEndPoint = exports.getQuickSilverEndPoint = function getQuickSilverEndPoint() {
  return (0, _url.getMsEndpointUrl)(QUICKSILVER.NAME);
};

// temp fix for china
var getConfigurationServiceEndpoint = exports.getConfigurationServiceEndpoint = function getConfigurationServiceEndpoint() {
  return (0, _url.getMsEndpointUrl)(CONFIGURATION.NAME).replace('.cn/', '.com/');
};